/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// 游戏业务导流金融
import { Component, Mixins } from 'vue-property-decorator';
import { isH5App } from '@/constant';
import HomeV2Status from '@/api/homeV2Status';
import { RouterH5Enum } from '@/router/router-names';
import { UserCreditOriginType } from '@/api/homeV2Status/types';
import { Loading } from '@/shared/utils/loading';
import FinanceBusiness from '@/mixins/finance-business';
import { namespace } from 'vuex-class';
import '@/views_v2/home/store';
import platform from '@/shared/utils/platform';
import { agreementService } from '@/service/confirm-agreements';

const style = require('./index.module.scss');
const button = require('./images/button.png');

const HomeStore = namespace('home');

@Component({ name: 'AboutUs' })
export default class AboutUs extends Mixins(FinanceBusiness) {
  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  private homeInfo: UserCreditOriginType | null = null;

  private ready = false;

  private async created() {
    // 获取用户是否有额度信息
    const creditCombineData = await HomeV2Status.getUserCredit();
    this.homeInfo = creditCombineData.businessData;

    this.ready = true;
    if (this.ready) {
      Loading.clearAll();
    }
    /** 提前加载用户留痕协议 */
    agreementService.preloadAgreementsData();
  }

  private async getLoan() {
    /** 因微信小程序环境，无法跳转至App，所以进入后续授信流程 */
    if (isH5App && !platform.isWechatMini) {
      this.$router.push(RouterH5Enum.redirectApp);
      return;
    }

    this.$ubtPageButton('Finance_Knowus_Getquota');

    const { creditStatus } = this.homeInfo || {};
    // 再次调用接口，阻止返回上一页面时，数据未刷新问题
    await this.getCreditData();
    // 申请额度，统一方法
    this.onApplyCredit(
      'about-us',
      'creditStatus',
      String(creditStatus),
    );
  }

  private renderLoading() {
    Loading.trigger(true);
  }

  private render() {
    return (
      this.ready ? (
        <div class={style.game_conduction}>
          {// 挂载身份证清晰分不够弹窗 dom
          this.getUpdatedIdentityPhotoDialog()
          }
          <div class={style.content}>
            <img src={button} class={style.button} onClick={this.getLoan.bind(this)}></img>
          </div>
        </div>
      )
        : this.renderLoading()
    );
  }
}
